exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "main[data-v-4c266f18]{min-height:50vh}", ""]);

